import { ActionNode } from '../Action/TypedNode'
import { ElementModel } from '../Element/ViewModel'
import { ActionCallElementDefinition } from './TypedDefinition'

import type { ActionSpecific } from '../Action/TypedNode'
import type { AnyExpressionSpecific } from '../Mustache'
import type { ViewScope } from '@rehaje/core'

export interface ActionCallElementSpecific extends ActionSpecific {
  props: {
    elementId?: AnyExpressionSpecific | string
    methodName?: AnyExpressionSpecific | string
    parameters?: Array<any | AnyExpressionSpecific>
  }
  type: `Action.CallElement`
}

export interface CallElementProps {
  elementId?: string
  methodName?: string
  parameters?: any[]
}

export class ActionCallElementNode extends ActionNode {
  static definition = ActionCallElementDefinition

  override async handler(props: CallElementProps, scope: ViewScope) {
    if (props.elementId) {
      const model = scope.variables[props.elementId]
      const methodName = props.methodName
      if (model instanceof ElementModel && methodName) {
        // @ts-ignore
        model[methodName]?.(...(props.parameters ?? []))
      }
    }
  }
}

declare global {
  export interface RehajeSpecifics {
    'Action.CallElement': ActionCallElementSpecific
  }
  export interface RehajeTypedNodes {
    'Action.CallElement': ActionCallElementNode
  }
}
